{
  "name": "1/4-Comma Meantone (pure thirds)",
  "description": "12-tone Quarter Comma Meantone: in the range from E♭ to G♯ each fifth is narrowed by 1/4 of a Quintal (Syntonic) Comma (dividing the ratio 81/80). Eight major thirds - E♭-G, B♭-D, F-A, C-E, G-B, D-F♯, A-C♯, E-G♯ - are pure 4:5 ratios. Notated using small letter-names to distinguish that the fifths are tempered.",
  "scale": [
    "76.04899926",
    "193.1568569",
    "310.2647146",
    "386.3137139",
    "503.4215715",
    "579.4705708",
    "696.5784285",
    "772.6274277",
    "889.7352854",
    "1006.843143",
    "1082.892142",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-MT-1_4-SC",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["c", "♯c", "d", "♭e", "e", "f", "♯f", "g", "♯g", "a", "♭b", "b"],
  "note_colors": [
    "#ffdbdb",
    "#eee9d3",
    "#f9f7eb",
    "#e2dfcf",
    "#f9f7eb",
    "#f9f7eb",
    "#eee9d3",
    "#f9f7eb",
    "#eee9d3",
    "#f9f7eb",
    "#e2dfcf",
    "#f9f7eb"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
